export default __webpack_public_path__ + "static/media/detail_mobile_14_5.c143c677.jpg";